import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/infinity.svg
 */
const IconInfinity: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M22.396 7.752C21.35 6.628 19.956 6 18.503 6c-1.452 0-2.848.628-3.893 1.752l-1.614 1.732a.254.254 0 00-.057.163c0 .061.02.12.057.164L14 10.914c.04.04.094.063.147.063a.203.203 0 00.146-.063l1.606-1.737c.699-.751 1.631-1.17 2.602-1.17.971 0 1.905.419 2.604 1.17.338.367.606.805.79 1.289.183.484.278 1.004.278 1.529 0 .525-.095 1.046-.278 1.53a3.978 3.978 0 01-.79 1.289c-.699.75-1.633 1.17-2.604 1.17-.97 0-1.903-.42-2.602-1.17L9.394 7.752c-1.045-1.122-2.44-1.75-3.89-1.75-1.452 0-2.845.628-3.89 1.75-.51.551-.918 1.21-1.195 1.94A6.494 6.494 0 000 11.997c0 .793.142 1.577.419 2.306.277.73.685 1.39 1.196 1.94 1.044 1.123 2.437 1.75 3.888 1.75s2.846-.627 3.89-1.75L11 14.513a.257.257 0 000-.329l-1.004-1.09a.2.2 0 00-.288 0L8.1 14.817c-.699.751-1.633 1.171-2.604 1.171-.971 0-1.903-.42-2.602-1.17A3.962 3.962 0 012.1 13.53a4.31 4.31 0 01-.278-1.53c0-.526.094-1.046.278-1.53.184-.484.455-.922.794-1.287.698-.752 1.63-1.173 2.602-1.173.971 0 1.905.421 2.604 1.173l6.495 7.064C15.64 17.372 17.036 18 18.488 18c1.453 0 2.848-.628 3.893-1.752.511-.55.918-1.21 1.196-1.94A6.508 6.508 0 0024 12.004a6.511 6.511 0 00-.415-2.307 5.989 5.989 0 00-1.19-1.944z"
      fill="currentColor"
    />
  </svg>
);

export default IconInfinity;
